<template minapp='mpx' xlang='wxml'>
  <es-overlay
  wx:if="{{option.overlay}}"
  show="{{option.show}}"
  position="fade"
  />
  <es-transition 
  show="{{option.show}}"
  custom-class="es-toast custom-class {{isText && 'es-toast--text'}}"
  name='center'
  >
    <view 
    class="es-toast__icon" 
    wx:if="{{option.name}}"
    >
      <es-icon name="{{option.name}}"></es-icon>
    </view>

    <view class="es-toast__text">
      {{option.message}}
    </view>

  </es-transition>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    data: {
      option: {
        overlay: true,
        show: false,
        name: '',
        message: ''
      }
    },

    computed: {
      isText() {
        return !this.option.name
      }
    },

    methods: {
      setOption(option) {
        this.option = Object.assign(this.option, option)
      },

      clear() {
        this.$set(this.option, 'show', false)
      }
    }
  })
</script>

<style lang='stylus' src='./style.styl'></style>

<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'es-overlay': '../overlay/index',
      'es-transition': '../transition/index',
      'es-icon': '../icon/index'
    }
  }
</script>

